export default __webpack_public_path__ + "static/media/electrolytedrink-wide@2x.ec8f9eee.jpg";